package net.kigawa.admin.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import kotlinx.browser.localStorage
import net.kigawa.admin.auth.AuthGuard
import net.kigawa.admin.auth.PagePermission
import net.kigawa.admin.layout.AppShell
import net.kigawa.admin.networkmap.NetworkMapPage

@Page("/network-map")
@Composable
fun NetworkMapRoute() {
    val ctx = rememberPageContext()
    // ネットワークマップはサーバー側でも所属組織で絞り込んで一般ユーザーに開放している
    // ため、adminロール要求はしない(issue #155の判断)。ただし表示には viewer 権限を
    // 要求する(AppShellのナビ表記と合わせる)。
    AuthGuard(requirePermission = PagePermission.VIEW_INFRASTRUCTURE) { state, _, provider ->
        var currentOrgId by remember { mutableStateOf<String?>(localStorage.getItem("selectedOrgId")) }
        val onOrgChange: (String?) -> Unit = { orgId ->
            currentOrgId = orgId
            if (orgId != null) {
                localStorage.setItem("selectedOrgId", orgId)
            } else {
                localStorage.removeItem("selectedOrgId")
            }
        }
        AppShell(
            rbac = state.rbac,
            accessToken = state.accessToken,
            currentOrgId = currentOrgId,
            onOrgChange = onOrgChange,
            authProvider = provider
        ) {
            NetworkMapPage(
                accessToken = state.accessToken,
                onBack = { ctx.router.navigateTo("/") }
            )
        }
    }
}
